import {Component, Inject} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {i18nService} from "src/app/service-utils/i18n.service";
import {customerNumberExistsValidator, emailValidator, requiredFieldValidator} from "../../../utils/validation/validators";

@Component({
  selector: 'app-account-super-admin-dialog',
  templateUrl: './account-super-admin-dialog.component.html',
  styleUrls: ['./account-super-admin-dialog.component.scss']
})
export class AccountSuperAdminDialogComponent {

  form: FormGroup;
  isActive: boolean;

  constructor(
    public dialogRef: MatDialogRef<AccountSuperAdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public i18nService: i18nService,
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.isActive = this.data?.item?.active;
    this.form = this.formBuilder.group({
      email: [this.data?.item?.email, [requiredFieldValidator(), emailValidator]],
      customerName: [this.data?.item?.customerName, requiredFieldValidator()],
      customerNumber: [this.data?.item?.customerNumber, [requiredFieldValidator(), customerNumberExistsValidator(this.data?.customerNumbers)]]
    });
  }

  save() {
    event.stopPropagation();

    this.form.get('customerNumber').markAsTouched();
    this.form.get('customerName').markAsTouched();
    this.form.get('email').markAsTouched();

    if (this.form.valid) {
      this.dialogRef.close({
        "id": this.data?.item?.id,
        "email": this.form.get("email").value,
        "customerName": this.form.get("customerName").value,
        "customerNumber": this.form.get("customerNumber").value,
        "active": this.isActive
      });
    }
  }

  discard() {
    this.dialogRef.close();
  }
}
